import { render } from "./Qaboard.vue?vue&type=template&id=f6bbf60c"
import script from "./Qaboard.vue?vue&type=script&lang=ts"
export * from "./Qaboard.vue?vue&type=script&lang=ts"
script.render = render

export default script